<div class="slds-notify_container" *ngIf="toastMessage$ | async as toastMessage">
  <ngl-toast
    *ngIf="toastMessage.message"
    [variant]="toastMessage.variant"
    (close)="toastMessage.message = undefined"
    [duration]="toastMessage.duration"
  >
    <h2 *ngIf="!toastMessage.translate" class="slds-text-heading_small">{{ toastMessage.message }}</h2>
    <h2 *ngIf="toastMessage.translate" class="slds-text-heading_small">
      {{ toastMessage.message | translate }}
    </h2>
  </ngl-toast>
</div>
